import React from "react";
import { formatDate, formatTime } from "@ca-dmv-radv/utilities";
import { useTranslation } from "@ca-dmv-radv/translation";

export default function DateAndTime({ selectedAppointment, lang }) {
  const { t } = useTranslation();

  return (
    <div className="w-100 bp-md:max-width--600 bg--blue-light-5 p-16 mb-24 print--pb-0 print--mb-10">
      <p className="text--gray-dark-2 text--700 text--xxsm text--uppercase mb-8">
        {t("screens-FinalConfirmation-dateAndTime", "Date and Time")}
      </p>
      <div className="mb-0">
        <p className="text--blue-dark-2 text--sm bp-sm:text--md text--700 mb-0">
          {formatDate(selectedAppointment?.date, lang)}{" "}
        </p>
        <p className="text--blue-dark-2 text--sm bp-sm:text--md text--700 mb-0">
          {formatTime(selectedAppointment?.time)}
        </p>
      </div>
    </div>
  );
}
